import {ServiceGlobal} from './service.global';
import {Injectable} from '@angular/core';
import 'rxjs/add/operator/toPromise';
import {API} from '../../config/api';


@Injectable()
export class DashBoardService extends ServiceGlobal {

    school_count:number;
    mentor_count:number;
    student_count:number;
    mentee_count:number;
    group_count:number;
    activity_count:number;
    attendance_count:number;
    outstanding_form_count:number;
    school_based_activity_count:number;
    english_small_group_count:number;
    individual_mentoring_count:number;

    tableName() { return 'dashboard'; }

    attributeLabels() {
        return Object.assign(super.attributeLabels(), {
            "school_count": "Schools",
            "mentor_count": "Mentors",
            "student_count": "Students",
            "mentee_count": "Mentees",
            "group_count": "Groups",
            "activity_count": "Activities",
            "attendance_count": "Attendance",
            "outstanding_form_count": "Outstanding Forms",
            "school_based_activity_count": "School-based activity",
            "english_small_group_count": "English small group",
            "individual_mentoring_count": " Individual mentoring",
        });
    }

    rule() {
        return Object.assign(super.rule(), {
            "school_count": {
                "default": "0",
                "type": "int",
                "size": 1
            },
        });
    }

    getData(school?: any, academicYear?: any) {
        var that = this;
        let header = this._db.getHeader();
        header.set('Content-Type', 'application/json');
        header.set('Authorization', 'Bearer ' +  localStorage.getItem('token'));
        this._db.setHeader(header);
        let linkDashboardData = API.INFORMATION;
        let data = {};
        if (school) {
          data['school'] = school;
        }

        if (academicYear) {
          data['academic_year'] = academicYear;
        }

        return this._db.get(linkDashboardData, data).then(rs => {
            if(rs) {
                that.setAttributes(rs.attributes);
                that._old_attributes = rs.attributes;
            }
            return Promise.resolve(rs);
        })
    }
}



// WEBPACK FOOTER //
// ./src/app/common/services/dashboard.service.ts